import { Message } from './messages';
import { User } from './user';

export class Thread {
    private id: String;
    private subject: String = '';
    private users: Array<User> = [];
    private messages: Array<Message> = [];
    private unreadMessages: Array<Message> = [];
    private amountMessages: Number = 0;
    private amountUnreadMessages: Number = 0;

    constructor(id: String, subject: String) {
        this.id = id;
        this.subject = subject;
    }

    public setId(id: String) {
        this.id = id;
    }

    public getId() {
        return this.id;
    }

    public setUsers(users: Array<User>) {
        this.users = users;
    }

    public getUsers() {
        return this.users;
    }

    public addUser(user: User) {
        this.users.push(user);
    }

    public addMessage(message: Message) {
        this.messages.push(message);
    }

    public getMessages() {
        return this.messages;
    }

    public setAmountUnreadMessages(amount: Number) {
        this.amountUnreadMessages = amount;
    }

    public getAmountUnreadMessages() { return this.amountUnreadMessages; }

    public addUnreadMessage(message: Message) {
        this.unreadMessages.push(message);
    }

    public getUnreadMessage(): Array<Message> {
        return this.unreadMessages;
    }

    public setSubject(subject: String) {
        this.subject = subject;
    }

    public getSubject() { return this.subject; }

    public setAmountMessages(amount: Number) { this.amountMessages = amount; }
    public getAmountMessages() { return this.amountMessages; }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/models/thread.ts